// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-dropdown-module__dropdown--mJMoR {
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
}

.src-js-components-dropdown-module__absentValue--duxFX {
  color: #dadada;
}

.src-js-components-dropdown-module__presentValue--acgPP {
  color: #ffffff;
}

.src-js-components-dropdown-module__disabled--cI_Ng {
  color: #8a8a8a;
}

.src-js-components-dropdown-module__error--w5lQ9 {
  border-color: #ff0000;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".dropdown {\n  background-color: #a8b0b8;\n  border: 1px solid #ffffff;\n}\n\n.absentValue {\n  color: #dadada;\n}\n\n.presentValue {\n  color: #ffffff;\n}\n\n.disabled {\n  color: #8a8a8a;\n}\n\n.error {\n  border-color: #ff0000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `src-js-components-dropdown-module__dropdown--mJMoR`,
	"absentValue": `src-js-components-dropdown-module__absentValue--duxFX`,
	"presentValue": `src-js-components-dropdown-module__presentValue--acgPP`,
	"disabled": `src-js-components-dropdown-module__disabled--cI_Ng`,
	"error": `src-js-components-dropdown-module__error--w5lQ9`
};
export default ___CSS_LOADER_EXPORT___;
